import * as React from 'react'
// libs
import { WrappedFieldArrayProps } from 'redux-form'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
import { AddButton } from 'components/Modals/SystemProcessModal/Form/components/views'
// utils
import { validateIp } from 'utils/apiClient'
// views
import { RowWrapper, Title, TrashIcon } from './views'

interface Props {
  title?: string
  addLabel?: string
}

const ipValidators = [validateIp]

const renderIpAddresses: React.FC<WrappedFieldArrayProps<string> & Props> = ({
  fields,
  title = 'Allowed IP addresses (leave empty to allow any):',
  addLabel = 'add IP'
}) => {
  const addField = () => fields.push('')

  const removeField = (idx: number) => () => fields.remove(idx)

  return (
    <div>
      <Title>{title}</Title>
      {fields.map((field, idx) => (
        <RowWrapper key={field}>
          <ReduxInput name={field} placeholder='e.g. 203.0.113.4 or 203.0.113.0/24' validate={ipValidators} />
          <TrashIcon data-testid='ip-list-remove' data-entity-id={idx} onClick={removeField(idx)} />
        </RowWrapper>
      ))}

      <AddButton data-testid='ip-list-add' onClick={addField}>
        + {addLabel}
      </AddButton>
    </div>
  )
}

export default renderIpAddresses
